module.exports = __webpack_public_path__ + "img/test-start-back.54b97a23.png";